module.exports = __webpack_public_path__ + "static/image 102-3cbf4f43012b8a262d15b3e7fcd8a403.png";